import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import {initStore} from './store'
import {Provider} from 'react-redux'
import {
  BrowserRouter,
  Switch,
  Route,
	Redirect
} from "react-router-dom";
import { ConfigProvider } from 'antd';
import moment from 'moment';
import './interceptor/index';
import { Login, Iframe, App, Dashboard } from './containers';
import routes from './routes';
import { loggedIn } from './utils/auth';
import { _session } from './utils/storage';
import zhCN from 'antd/es/locale/zh_CN';
import './global.scss'
import './iconfont.css';
import './normalize.css'
import "react-chat-elements/dist/main.css"
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

class Main extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLogin: false
		}
	}
	componentDidMount() {
		// 刷新或者退出登录重新进入，都清除本地session中存储的风控相关内容
		_session.remove('riskCode');
		_session.remove('accessTokenBy5gCall');
		if (!loggedIn()) {
			this.props.history.replace('/login');
			return;
		}
		this.setState({
			isLogin: true
		})
	}
	
	render() {
		return this.state.isLogin ? <App><Dashboard>{routes}</Dashboard></App> : null
	}
}
class Root extends Component {
	//Render the LSP Agent site
	render() {
		return (
			<React.Fragment>
				<Provider store={initStore}>
					<BrowserRouter>
						<Switch>
							<Route exact path='/login' component={Login} />
							<Route exact path='/iframe/:url' component={Iframe} />
							<Route path='/' component={Main} />
							<Redirect from="*" to="/" />
						</Switch>
					</BrowserRouter>
				</Provider>
			</React.Fragment>
		)
	}
}

// ReactDOM.render(<Root/>, document.getElementById('root'));
ReactDOM.render(
	// <Root />,
	<ConfigProvider locale={zhCN}><Root /></ConfigProvider>,
	document.getElementById('root')
)
